// extracted by mini-css-extract-plugin
export default {"container":"PageSummary_container__je2vD"};